module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v("Mobilne verzije")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button button-outline",
    staticStyle: {
      "background": "#2b542c",
      "color": "white"
    },
    on: {
      "click": function($event) {
        return _vm.openAddVersionModal()
      }
    }
  }, [_vm._v(" Dodaj verziju\n         ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "input",
    staticStyle: {
      "width": "90%",
      "border-radius": "10px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Pretraga",
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed",
    staticStyle: {
      "margin-bottom": "100px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredUsers), function(obj) {
    return _c('tr', {
      staticStyle: {
        "color": "white",
        "background-color": "#4E5066 !important"
      }
    }, [_c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(obj.system))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(obj.version) + " ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('b', [_vm._v(_vm._s(obj.mandatory ? 'DA' : 'NE'))])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(obj.companyNotes))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_vm._v(_vm._s(obj.courierNotes))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "20px",
        "color": "white"
      }
    }, [_c('input', {
      staticClass: "input",
      staticStyle: {
        "background": "#843534"
      },
      attrs: {
        "type": "button",
        "placeholder": "Obriši",
        "name": "Obriši",
        "value": "Obriši"
      },
      on: {
        "click": function($event) {
          return _vm.deleteVersion(obj)
        }
      }
    })])])
  }), 0)])])])]), _vm._v(" "), _c('add-version-modal', {
    attrs: {
      "show": _vm.openAddVersion
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "200px",
      "color": "white"
    }
  }, [_vm._v("Sistem")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v("Verzija")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px",
      "color": "white"
    }
  }, [_vm._v("Obavezan update")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Text za kompaniju")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "1000px",
      "color": "white"
    }
  }, [_vm._v("Text za kurire")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "150px",
      "color": "white"
    }
  }, [_vm._v("Obriši")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24c9d2fc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileVersion/ChangeMobileVersion.vue
// module id = 461
// module chunks = 1